export {
  CheckInTableComponent,
  type CheckInEntry,
} from './check-in-table/check-in-table.component';
export {
  CheckOutTableComponent,
  type CheckOutEntry,
} from './check-out-table/check-out-table.component';
export { WaitingListTableComponent } from './waiting-list-table/waiting-list-table.component';
export type { WaitingListEntry as WaitingListEntryUI } from './waiting-list-table/waiting-list-table.component';
